import axios from 'axios';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import logoAidu from 'assets/images/logo-aidu.svg';
import {config} from 'config';
import {getBookingInProcess} from 'redux/uiState/layout/booking/reducer';

// Default/barebones header information to be used while directus response is still pending
const DEFAULT_CONFIG = {
  pageType: 'book',
  favouriteList: false,
  login: false,
  sslIcon: true,
  accessibilityToggleEnabled: false,
  logo: {
    alt: config.portalOrigin,
    isClickable: false,
    type: 'url',
    url: config.logo ? config.logo : logoAidu,
  },
};

export const useDirectusHeader = () => {
  const [loading, setLoading] = useState(false);
  const [headerConfig, setHeaderConfig] = useState(DEFAULT_CONFIG);
  const bookingInProcess = useSelector(getBookingInProcess);

  const pathParts = location.pathname.split('/').slice(1);
  const pageTypes =
    pathParts.includes('confirmation') || bookingInProcess
      ? 'bookConfirm'
      : 'book';

  const getDirectusConfig = async () => {
    try {
      setLoading(true);

      const {data} = await axios.get(
        `${process.env.CONFIG_SERVICE_URL}/config?agent=${config.agent}&pageTypes=${pageTypes}`
      );

      const headerConfigResponse = data.headers[0];

      if (!headerConfigResponse) {
        return;
      }

      // 1. We override the hotlines with the ones from our own config.service,
      // because directus isn't flexible enough to provide the data as we need it.
      // 2. We don't need link masking, because our pages aren't indexed by search-engines.
      // But we want to use the same config as SEARCH (which enables link masking).
      // So we override "masked" here to always be false.
      setHeaderConfig({
        ...headerConfigResponse,
        menu: headerConfigResponse.menu
          ? {
              ...headerConfigResponse.menu,
              items: headerConfigResponse.menu.items.map((item) => ({
                ...item,
                link: item.link ? {...item.link, masked: false} : undefined,
                items: item.items
                  ? item.items.map((subItem) => ({
                      ...subItem,
                      items: subItem.items.map((secondSubItem) => ({
                        ...secondSubItem,
                        masked: false,
                      })),
                    }))
                  : undefined,
              })),
            }
          : undefined,
        hotline: {
          ...headerConfigResponse.hotline,
          numbers: {
            sm: config.service.phone.phone,
            md: config.service.phone.tablet,
            lg: config.service.phone.desktop,
          },
          openingHours: {
            from: config.service.defaultOpeningHours.timeFrom,
            to: config.service.defaultOpeningHours.timeUntil,
          },
        },
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDirectusConfig();
  }, []);

  return {
    headerLoading: loading,
    headerConfig,
  };
};
